import React, { Component } from "react";
import { connect } from 'react-redux';

import home_video from '../media/home_video.mp4';

class HomeVideo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tag_counter: null,
            tag_arr: null
        }
    }

    componentDidMount() {
        if (this.state.tag_arr === null) {
            fetch(this.props.url+'wp-json/wp/v2/tags').then((response) => {
                if(!response.ok) {
                    console.log("Что-то не так с тегами: " + response.statusText);
                }
                else return response;
            })
            .then((response) => response.json())
            .then((data) => {
                if (data.length > 0) {
                    this.setState({
                        tag_arr: data
                    })
                }
            })
        }
    }

    componentDidUpdate() {
        if (this.state.tag_arr !== null && this.state.tag_counter === null) {
            this.setState({
                tag_counter: this.state.tag_arr.length-1
            })
        }
    }

    render() {
        let tag = 'main__media';
        if (this.state.tag_counter !== null) {
            tag += ' tag';
        }
        return(
            <div className={tag}>
                <video autoPlay loop className="media__video" src={home_video} alt="main-home page media" playsInline muted />
                {
                    this.state.tag_counter !== null ? 
                    <div>
                        <div className="media__mask"></div>
                        <p className="media__text">{this.state.tag_arr[this.state.tag_counter].name}</p>
                    </div> : <p className="media__text" itemProp="name">Создаём посуду с теплом и любовью</p>
                }
                <div className="page-description" itemProp="description">
                    *текст описания страницы*
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    url: state.site_options.SITE_URL
})

export default connect(mapStateToProps)(HomeVideo);